// Output order keeps the original seven columns stable for signal consumers.
export const PIVOT_LEVELS=['P','R1','R2','R3','S1','S2','S3','R4','S4','R5','S5'];
export function pivotLevels(type,high,low,close,previousOpen,currentOpen){
    if(![high,low,close].every(Number.isFinite))return Array(11).fill(NaN);
    const span=high-low;
    let p=(high+low+close)/3;
    let r1=2*p-low,r2=p+span,r3=high+2*(p-low),s1=2*p-high,s2=p-span,s3=low-2*(high-p),r4=NaN,s4=NaN,r5=NaN,s5=NaN;
    if(type==='Fibonacci'){
        [r1,r2,r3]=[.382,.618,1].map(ratio=>p+ratio*span);
        [s1,s2,s3]=[.382,.618,1].map(ratio=>p-ratio*span);
    }else if(type==='Woodie'){
        p=(high+low+2*currentOpen)/4;
        r1=2*p-low;s1=2*p-high;r2=p+span;s2=p-span;
        r3=high+2*(p-low);s3=low-2*(high-p);r4=r3+span;s4=s3-span;
    }else if(type==='Classic'){
        r3=p+2*span;s3=p-2*span;r4=p+3*span;s4=p-3*span;
    }else if(type==='DM'){
        const weighted=close===previousOpen?high+low+2*close:close>previousOpen?2*high+low+close:high+2*low+close;
        p=weighted/4;r1=weighted/2-low;s1=weighted/2-high;
        r2=r3=s2=s3=NaN;
    }else if(type==='Camarilla'){
        [r1,r2,r3,r4]=[12,6,4,2].map(divisor=>close+1.1*span/divisor);
        [s1,s2,s3,s4]=[12,6,4,2].map(divisor=>close-1.1*span/divisor);
        r5=low!==0?high/low*close:NaN;s5=2*close-r5;
    }else{
        r4=3*p+high-3*low;s4=3*p-3*high+low;
        r5=4*p+high-4*low;s5=4*p-4*high+low;
    }
    return [p,r1,r2,r3,s1,s2,s3,r4,s4,r5,s5];
}
export function pivotPeriodStart(time,period,chartMs){
    if(period==='Auto')period=chartMs<=900000?'Day':chartMs<86400000?'Week':'Month';
    const date=new Date(time),year=date.getUTCFullYear(),month=date.getUTCMonth();
    if(period==='Bar')return time;
    if(period==='Week')return Math.floor((time+259200000)/604800000)*604800000-259200000;
    if(period==='Month')return Date.UTC(year,month,1);
    if(period==='Quarter')return Date.UTC(year,Math.floor(month/3)*3,1);
    if(period.endsWith('Years')||period==='Year'){
        const years=parseInt(period)||1;return Date.UTC(Math.floor(year/years)*years,0,1);
    }
    return Math.floor(time/86400000)*86400000;
}
